import { useMemo } from 'react'
import { useReactiveVar } from '@apollo/client'
import { Flex, Text } from '@radix-ui/themes'
import { DataTestIDs } from 'shared/constants'
import { balanceVar } from 'shared/store/balance-store'
import { activeBalanceClaimSwitchTypeVar } from '../store/switch-types'
import { ClaimBalanceSwitchTypes } from '../types'
import { getFormattedBalances } from '../utils/get-formatted-balances'
import styles from '../approved-balance.module.scss'

export const ApprovedBalanceInputLabel = () => {
  const activeType = useReactiveVar(activeBalanceClaimSwitchTypeVar)

  const balance = useReactiveVar(balanceVar)

  const { formattedBalance, formattedTreasury } = getFormattedBalances(balance)

  const fieldTitle = useMemo(() => {
    if (activeType === ClaimBalanceSwitchTypes.Deposit) {
      return 'WALLET USDT'
    }

    if (activeType === ClaimBalanceSwitchTypes.Claim) {
      return 'AVAILABLE TO CLAIM'
    }

    return 'BALANCE'
  }, [activeType])

  const balanceValue = useMemo(() => {
    if (activeType === ClaimBalanceSwitchTypes.Deposit) {
      return formattedBalance
    }

    if (activeType === ClaimBalanceSwitchTypes.Claim) {
      return formattedTreasury
    }

    return formattedBalance
  }, [activeType, formattedTreasury, formattedBalance])

  return (
    <Flex
      className={styles.approvedFormAmountLabel}
      gap={'1'}
      pl={'2'}
    >
      <Text
        size={'1'}
        weight={'bold'}
        color='gray'
      >
        {fieldTitle}:
      </Text>

      <Text
        size={'1'}
        weight={'bold'}
        className={'color-white'}
        data-testid={DataTestIDs.treasureAvailableAmount}
      >
        {balanceValue}
      </Text>
    </Flex>
  )
}
